import { Command } from 'commander';
import chalk from 'chalk';
import Table from 'cli-table3';
import { ConfigService } from '../../services/config.service.js';
import { ValidationError } from '../../errors/index.js';

interface Preset {
    slug: string;
    name: string;
    description: string;
    version: string;
    tags: string[];
    stack: {
        frontend?: string | null;
        backend?: string | null;
        css?: string | null;
        database?: string | null;
        language?: string | null;
    };
    downloads: number;
}

interface ListPresetsResponse {
    presets: Preset[];
    total: number;
}

export function createRulesListCommand(): Command {
    return new Command('list')
        .description('List available rule presets')
        .option('--json', 'Output as JSON')
        .action(async (options) => {
            const configService = new ConfigService();
            const config = await configService.load();

            if (!config) {
                throw new ValidationError('Not initialized. Run "jai1 auth" first.');
            }

            console.log(chalk.cyan('📋 Đang tải danh sách rule presets...'));
            console.log();

            try {
                const response = await fetch(`${config.apiUrl}/api/rules/presets`, {
                    headers: {
                        'JAI1-Access-Key': config.accessKey,
                    },
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch presets: ${response.statusText}`);
                }

                const data = (await response.json()) as ListPresetsResponse;

                if (options.json) {
                    console.log(JSON.stringify(data, null, 2));
                    return;
                }

                if (data.total === 0) {
                    console.log(chalk.yellow('Không có presets nào.'));
                    return;
                }

                console.log(
                    chalk.green(`✓ Tìm thấy ${chalk.bold(data.total)} preset${data.total > 1 ? 's' : ''}`)
                );
                console.log();

                for (const preset of data.presets) {
                    // Preset header
                    console.log(chalk.bold.cyan(`📦 ${preset.slug}`));

                    // Details table
                    const table = new Table({
                        style: { head: [], border: ['gray'], compact: true },
                        colWidths: [15, 55],
                    });

                    table.push(
                        [chalk.dim('Tên'), chalk.white(preset.name)],
                        [chalk.dim('Mô tả'), chalk.white(preset.description)],
                        [chalk.dim('Version'), chalk.green(`v${preset.version}`)]
                    );

                    // Stack info
                    const stackParts: string[] = [];
                    if (preset.stack.frontend) stackParts.push(preset.stack.frontend);
                    if (preset.stack.backend) stackParts.push(preset.stack.backend);
                    if (preset.stack.css) stackParts.push(preset.stack.css);
                    if (preset.stack.database) stackParts.push(preset.stack.database);
                    if (stackParts.length > 0) {
                        table.push([chalk.dim('Stack'), chalk.yellow(stackParts.join(' + '))]);
                    }

                    table.push(
                        [chalk.dim('Tags'), chalk.dim(preset.tags.join(', ') || '-')],
                        [chalk.dim('Downloads'), chalk.white(preset.downloads.toString())]
                    );

                    console.log(table.toString());
                    console.log();
                }

                console.log(chalk.dim('💡 Chạy "jai1 rules apply <name>" để áp dụng preset'));
            } catch (error) {
                throw new Error(
                    `Lỗi khi tải presets: ${error instanceof Error ? error.message : String(error)}`
                );
            }
        });
}
